import { useState } from "react";
import { useAuthentication } from "../../Hooks/useAuthentication";
import { useToast } from "../../Contexts/Toast/toast.provider";
import useStore from "../../useStore";
import CompleteProfileModal from "../Layout/CompleteProfile/CompleteProfileModal";

/**
 * Guard global — se monta una sola vez en el Router.
 * Si el usuario está autenticado y tiene profileIncomplete=true en localStorage,
 * muestra el modal de completar perfil encima de cualquier página.
 * No se puede cerrar hasta llenar phone + dirección.
 */
export default function ProfileGuard() {
  const { isAuthenticated, phone } = useAuthentication();
  const { fetchDataUpdateProfile } = useStore();
  const showToast = useToast();

  // Estado local para forzar re-render tras guardar
  const [done, setDone] = useState(false);

  // Si el JWT ya trae teléfono (sesión actualizada), limpiar el flag y no mostrar
  if (isAuthenticated && phone) {
    localStorage.removeItem("profileIncomplete");
  }

  // Mostrar solo si: autenticado + flag activo + JWT sin teléfono + no guardó en esta sesión
  const needsCompletion =
    !done &&
    isAuthenticated &&
    !phone &&
    localStorage.getItem("profileIncomplete") === "true";

  if (!needsCompletion) return null;

  // Nombre del usuario desde logindata
  const loginData = (() => {
    try { return JSON.parse(localStorage.getItem("logindata") || "{}"); }
    catch { return {}; }
  })();
  const userName = loginData?.data?.name || "";

  const handleSave = async ({ phone, delivery }) => {
    const res = await fetchDataUpdateProfile({ phone, delivery });
    if (res?.statusCode === 200) {
      showToast("success", "¡Perfil completado! Bienvenido a BubUp 🎉");
      setDone(true); // oculta el modal sin recargar la página
    } else {
      showToast("error", res?.message || "No se pudo guardar el perfil. Intenta de nuevo.");
    }
  };

  return (
    <CompleteProfileModal
      userName={userName}
      onSave={handleSave}
    />
  );
}
